import { ChangeEvent, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styled from "styled-components";
import api from "../../../../Component/axios_Interceptor/api";
import api2 from "../../../../Component/axios_Interceptor/api2";
import { Live_rn_notice } from "../../../../Component/Interface/Live";
import url from "../../../../Component/server";
import { fontStyles } from "../../../../Component/style/common_font";
import { RowView, RowView2 } from "../../../../Component/style/common_style";

const NotiFy = styled(RowView)`
  width: 100%;
  overflow: hidden;
  margin-bottom: 38px;
`;
const InsertArea = styled.div`
  width: 24rem;
  div.btnarea {
    font-size: 20px;
    max-width: 24rem;
    margin-bottom: 0.5rem;
    ${fontStyles.semiBold}
  }
  div.titlearea {
    color: #c6c6c6;
    cursor: pointer;
  }
  div.this {
    color: #2d2d2d;
  }
  div.bar {
    width: 1px;
    height: 16px;
    margin: 0rem 1rem;
    background-color: #c6c6c6;
  }
  span {
    padding: 0.4rem 1.6rem;
    margin-left: 0.5rem;
    font-size: 16px;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
  textarea,
  input {
    flex: 1;
    width: 100%;
    box-sizing: border-box;
    padding: 1rem;
    ${fontStyles.regular}
    font-size: 16px;
    border: 1px solid #f0f0f0;
    border-radius: 8px;
    outline: 0;
    resize: none;
    &:hover,
    &:focus {
      border: 1px solid #454545;
    }
    &::placeholder {
      color: #c6c6c6;
    }
  }
`;

const ScrollArea = styled(RowView2)`
  flex: 1;
  width: 10rem;
  margin-left: 1rem;
  overflow-y: hidden;
  overflow-x: scroll;
  &::-webkit-scrollbar {
    width: 12px;
    background-color: #f8f8f8;
  }
  &::-webkit-scrollbar-thumb {
    background: #d9d9d9;
    &:hover {
      background: #bdbdbd;
    }
  }
`;
const Board = styled.div`
  flex-shrink: 0;
  width: 17rem;
  padding: 1rem;
  margin-right: 0.5rem;
  margin-bottom: 0.5rem;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  div.title {
    height: 1.2rem;
    margin: 0.5rem 0;
    ${fontStyles.semiBold}
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  div.content {
    height: 3.6rem;
    display: -webkit-box;
    word-wrap: break-word;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  div.gray {
    margin-top: 0.5rem;
    font-size: 14px;
    color: #8e8e8e;
  }
  div.bar {
    width: 1px;
    height: 15px;
    margin: 0rem 0.5rem;
    background-color: #c6c6c6;
  }
  span {
    cursor: pointer;
    &:hover {
      color: #454545;
    }
  }
`;

interface Notifyprops {
  notifyType: string;
  setNotifyType: React.Dispatch<React.SetStateAction<string>>;
}

const Detail_Notify = (props: Notifyprops) => {
  const { seq } = useParams();
  const notifyType = props.notifyType;
  const setNotifyType = props.setNotifyType;

  const [hasLn, setHasLn] = useState(false); // 등록된 ln이 있는지 여부
  const [ln_seq, setLn_seq] = useState<number | null>(null);
  const [ln_content, setLn_content] = useState("");
  const [rn_list, setRn_list] = useState<Live_rn_notice[]>([]);
  const [rn_seq, setRn_seq] = useState<number | null>(null);
  const [rn_title, setRn_title] = useState("");
  const [rn_content, setRn_content] = useState("");

  const setting_ln_contnet = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setLn_content(e.target.value);
  const setting_rn_title = (e: ChangeEvent<HTMLInputElement>) =>
    setRn_title(e.target.value);
  const setting_rn_contnet = (e: ChangeEvent<HTMLTextAreaElement>) =>
    setRn_content(e.target.value);

  const testList = new Array(2).fill({});

  const classType = (page: string) => {
    if (notifyType === page) return "this";
    return "";
  };

  const load_notice = async () => {
    try {
      const res = await api.get(url.Communication_url.get_live_notice, {
        params: { seq: seq, type: notifyType },
      });
      if (notifyType === "ln") {
        setLn_seq(res.data[0]?.seq || null);
        setLn_content(res.data[0]?.content || "");
        setHasLn(res.data.length !== 0);
      } else {
        setRn_list(res.data || []);
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };
  useEffect(() => {
    load_notice();
  }, [notifyType]);

  const noticeBtn = () => {
    if ((notifyType === "ln" && hasLn) || (notifyType === "rn" && rn_seq)) {
      modify_notice();
      return;
    }
    insert_notice();
  };
  const insert_notice = async () => {
    if (notifyType === "ln" && ln_content === "") {
      alert("내용을 입력해주세요.");
      return;
    }

    try {
      const res = await api.post(url.Communication_url.create_live_notice, {
        live_seq: seq,
        type: notifyType,
        ...(notifyType === "ln" && { content: ln_content }),
        ...(notifyType === "rn" && { title: rn_title, content: rn_content }),
      });

      if (res.data === "성공") {
        alert("공지가 등록되었습니다.");
        if (notifyType === "ln") {
          setHasLn(true);
          load_notice();
          return;
        }
        if (notifyType === "rn") {
          setRn_title("");
          setRn_content("");
          load_notice();
          return;
        }
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };
  const modify_notice = async () => {
    if (notifyType === "ln" && ln_content === "") {
      alert("내용을 입력해주세요.");
      return;
    }

    try {
      const res = await api.patch(url.Communication_url.modify_live_notice, {
        ...(notifyType === "ln" && {
          seq: ln_seq,
          content: ln_content,
        }),
        ...(notifyType === "rn" && {
          seq: rn_seq,
          title: rn_title,
          content: rn_content,
        }),
      });

      if (res.data === "성공") {
        alert("공지가 수정되었습니다.");
      }
      if (notifyType === "rn") {
        const updateList = rn_list.map((item) =>
          item.seq === rn_seq
            ? { ...item, title: rn_title, content: rn_content }
            : item
        );
        setRn_list(updateList);

        setRn_title("");
        setRn_content("");
        setRn_seq(null);
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  const modify_rn = async (title: string, content: string, seq: number) => {
    setRn_title(title);
    setRn_content(content);
    setRn_seq(seq);
  };
  const delete_rn = async (seq: number) => {
    if (!window.confirm("정말 삭제하시겠습니까?")) {
      return;
    }

    try {
      const res = await api.delete(url.Communication_url.delete_live_notice, {
        data: { seq: seq },
      });

      if (res.data === "성공") {
        alert("삭제 되었습니다.");
        setRn_list(rn_list.filter((item) => item.seq !== seq));
      }
    } catch (error) {
      console.error("데이터 로드 실패1:", error);
    }
  };

  return (
    <NotiFy className="bottom">
      <InsertArea>
        <RowView className="btnarea">
          <RowView2 className="titlearea">
            <div
              className={classType("ln")}
              onClick={() => setNotifyType("ln")}
            >
              라이브 공지사항
            </div>
            <div className="bar" />
            <div
              className={classType("rn")}
              onClick={() => setNotifyType("rn")}
            >
              상시 공지사항
            </div>
          </RowView2>
          <span onClick={noticeBtn}>등록</span>
        </RowView>

        {notifyType === "ln" ? (
          <textarea
            style={{ height: "10rem" }}
            placeholder="내용을 입력해주세요."
            value={ln_content}
            onChange={setting_ln_contnet}
            maxLength={1000}
          />
        ) : (
          <>
            <input
              style={{ height: "3rem", marginBottom: "0.5rem" }}
              placeholder="제목을 입력해주세요."
              value={rn_title}
              onChange={setting_rn_title}
            />
            <textarea
              style={{ height: "7rem" }}
              placeholder="내용을 입력해주세요."
              value={rn_content}
              onChange={setting_rn_contnet}
              maxLength={1000}
            />
          </>
        )}
      </InsertArea>

      {notifyType !== "ln" && testList.length !== 0 && (
        <ScrollArea>
          {rn_list.map((data, idx) => {
            return (
              <Board key={idx}>
                <div className="title">{data.title}</div>
                <div className="content">{data.content}</div>
                <RowView className="gray">
                  <div>{data.crt_dt}</div>
                  <RowView>
                    <span
                      onClick={() =>
                        modify_rn(data.title, data.content, data.seq)
                      }
                    >
                      수정
                    </span>
                    <div className="bar" />
                    <span onClick={() => delete_rn(data.seq)}>삭제</span>
                  </RowView>
                </RowView>
              </Board>
            );
          })}
        </ScrollArea>
      )}
    </NotiFy>
  );
};

export default Detail_Notify;
